import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

import { IBeetleId, IBeetleStatus } from './types';
import { methods } from './serviceHandlerRequest';
import { SupportContentType } from './types/supportContentType';

export const updateStatusBatchMutationKey: MutationKey = ['mutation', 'updateStatus', 'batch'];

export const useUpdateBatchStatus = (
  method: SupportContentType,
  options?: UseMutationOptionsExtended<
    CommonSuccess,
    GenericFailure | Error,
    { ids: IBeetleId[]; status: IBeetleStatus; env: Environment }
  >
) => {
  const request = methods(method);
  return useEitherMutation(({ ids, status, env }) => request.updateBatch(ids, status, env), {
    mutationKey: updateStatusBatchMutationKey.concat(method),
    ...options,
  });
};
